import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const handleScrollToTop = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (window.location.pathname === '/' || window.location.pathname === '') {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-t from-black to-gray-900/90 border-t border-gray-800/50 mt-auto">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <Link to="/" onClick={handleScrollToTop} className="inline-flex items-center gap-4 mb-5 group">
              <img src="/public/assets/images/paylogo.png" alt="CineClubs" className="h-24 w-auto" />
              <div className="flex flex-col">
                <span className="text-2xl font-black tracking-tight leading-tight footer-logo-text">CINECLUBS</span>
                <span className="text-xs text-gray-400 tracking-[0.15em] uppercase mt-1">Stream Together</span>
              </div>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed">
              Watch movies together with friends, join live streams, and connect with movie lovers worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Explore</h3>
            <ul className="space-y-3">
              <li className="footer-link-item" style={{ '--delay': '0.1s' } as React.CSSProperties}>
                <Link to="/" onClick={handleScrollToTop} className="text-gray-400 hover:text-red-500 transition-all text-sm flex items-center gap-2 hover:translate-x-2">
                  <i className="fas fa-home w-4 text-xs"></i> Home
                </Link>
              </li>
              <li className="footer-link-item" style={{ '--delay': '0.15s' } as React.CSSProperties}>
                <Link to="/movies" className="text-gray-400 hover:text-red-500 transition-all text-sm flex items-center gap-2 hover:translate-x-2">
                  <i className="fas fa-film w-4 text-xs"></i> Movies
                </Link>
              </li>
              <li className="footer-link-item" style={{ '--delay': '0.2s' } as React.CSSProperties}>
                <Link to="/streams" className="text-gray-400 hover:text-red-500 transition-all text-sm flex items-center gap-2 hover:translate-x-2">
                  <i className="fas fa-broadcast-tower w-4 text-xs"></i> Live Streams
                </Link>
              </li>
              <li className="footer-link-item" style={{ '--delay': '0.25s' } as React.CSSProperties}>
                <Link to="/watch-party/create" className="text-gray-400 hover:text-red-500 transition-all text-sm flex items-center gap-2 hover:translate-x-2">
                  <i className="fas fa-users w-4 text-xs"></i> Watch Party
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4 text-lg">Legal</h3>
            <ul className="space-y-3">
              <li className="footer-link-item" style={{ '--delay': '0.3s' } as React.CSSProperties}>
                <Link to="/privacy-policy" className="text-gray-400 hover:text-red-500 transition-all text-sm flex items-center gap-2 hover:translate-x-2">
                  <i className="fas fa-shield-alt w-4 text-xs"></i> Privacy Policy
                </Link>
              </li>
              <li className="footer-link-item" style={{ '--delay': '0.35s' } as React.CSSProperties}>
                <Link to="/terms" className="text-gray-400 hover:text-red-500 transition-all text-sm flex items-center gap-2 hover:translate-x-2">
                  <i className="fas fa-file-contract w-4 text-xs"></i> Terms of Service
                </Link>
              </li>
              <li className="footer-link-item" style={{ '--delay': '0.4s' } as React.CSSProperties}>
                <Link to="/cookies" className="text-gray-400 hover:text-red-500 transition-all text-sm flex items-center gap-2 hover:translate-x-2">
                  <i className="fas fa-cookie-bite w-4 text-xs"></i> Cookie Policy
                </Link>
              </li>
              <li className="footer-link-item" style={{ '--delay': '0.45s' } as React.CSSProperties}>
                <Link to="/contact" className="text-gray-400 hover:text-red-500 transition-all text-sm flex items-center gap-2 hover:translate-x-2">
                  <i className="fas fa-envelope w-4 text-xs"></i> Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800/50 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {currentYear} CineClubs. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs flex items-center gap-1">
            Made with <i className="fas fa-heart text-red-500 text-xs animate-pulse"></i> for movie lovers
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
